
import SEOHead from '../../components/seo/SEOHead';
import AboutHeroSection from './components/AboutHeroSection';
import CompanyStorySection from './components/CompanyStorySection';
import TeamSection from './components/TeamSection';
import CultureSection from './components/CultureSection';
import HonorsSection from './components/HonorsSection';

export default function About() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "关于顺年陈",
    "description": "了解顺年陈的品牌故事、企业文化和团队理念。我们致力于成为年份茶行业的标准制定者与引领者。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
    "mainEntity": {
      "@type": "Organization",
      "name": "顺年陈",
      "foundingDate": "2020",
      "description": "专注高端年份普洱茶的品牌",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "CN",
        "addressLocality": "云南省",
        "addressRegion": "昆明市"
      }
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="关于顺年陈 - 年份茶行业的标准制定者"
        description="了解顺年陈的品牌故事、企业文化和团队理念。我们致力于成为年份茶行业的标准制定者与引领者，以透明化体系重构行业生态。"
        keywords="顺年陈,关于我们,品牌故事,企业文化,年份茶,普洱茶品牌"
        canonical="/about"
        structuredData={structuredData}
      />
      <AboutHeroSection />
      <CompanyStorySection />
      <TeamSection />
      <CultureSection />
      <HonorsSection />
    </div>
  );
}
